module.exports = __webpack_public_path__ + "img/117.34572a43.jpg";